import { ConditionalWrapper } from "components/conditional-wrapper";

import { PopoverMode } from "./enums";
import {
  StyledCustomizedPopoverGridFlexDirection,
  StyledCustomizedPopoverGridOverflow,
  StyledCustomizedPopoverTypography,
  StyledPopover,
} from "./styles";
import { IPopoverProps } from "./types";

const CustomizedPopover: React.FC<IPopoverProps> = ({
  children,
  arrowPosition,
  popoverTitle,
  mode = PopoverMode.DARK,
  ...props
}: IPopoverProps) => {
  return (
    <StyledPopover
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        style: {
          ...(arrowPosition && {
            overflowY: "unset",
            overflowX: "unset",
          }),
        },
      }}
      arrowPosition={arrowPosition}
      mode={mode}
      {...props}
      container={props.container ?? document.getElementById("root")}
    >
      <StyledCustomizedPopoverGridOverflow>
        <ConditionalWrapper
          condition={Boolean(popoverTitle)}
          wrapper={(children) => (
            <StyledCustomizedPopoverGridFlexDirection container>
              <StyledCustomizedPopoverTypography variant="subtitle2">
                {popoverTitle}
              </StyledCustomizedPopoverTypography>
              {children}
            </StyledCustomizedPopoverGridFlexDirection>
          )}
        >
          {children}
        </ConditionalWrapper>
      </StyledCustomizedPopoverGridOverflow>
    </StyledPopover>
  );
};

export default CustomizedPopover;
